import React from "react"

const Footer = () => {
  return (
    <footer>
      <p>copyright &copy; Roberto Castelli</p>
      <p>robertocastelli.dev</p>
    </footer>
  );
};

export default Footer;
